import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Loader2, Tag, CheckCircle } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AffiliateCodeInput = ({ cartTotal = 0, onApply }) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleValidate = async () => {
    if (!code.trim()) {
      toast.error('Please enter an affiliate or campaign code');
      return;
    }

    setLoading(true);
    try {
      // First try campaign validation
      const res = await axios.post(`${API_URL}/api/affiliates/validate-campaign?code=${code}&cart_total=${cartTotal}`);
      
      if (res.data.valid) {
        onApply(res.data);
        toast.success(res.data.message || 'Code applied successfully!');
        setCode('');
      }
    } catch (error) {
      // If campaign validation fails, try regular affiliate validation
      try {
        const res = await axios.get(`${API_URL}/api/affiliates/validate?code=${code}&cart_total=${cartTotal}`);
        if (res.data.valid) {
          onApply({
            ...res.data,
            is_campaign: false
          });
          toast.success(res.data.message || 'Affiliate code applied!');
          setCode('');
        }
      } catch (err) {
        toast.error(error.response?.data?.detail || 'Invalid code');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex gap-2">
      <Input
        value={code}
        onChange={(e) => setCode(e.target.value.toUpperCase())}
        placeholder="Enter affiliate or campaign code"
        className="flex-1"
        onKeyDown={(e) => e.key === 'Enter' && handleValidate()}
        data-testid="affiliate-code-input"
      />
      <Button
        onClick={handleValidate}
        disabled={loading || !code.trim()}
        variant="outline"
        data-testid="apply-affiliate-code-btn"
      >
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Apply'}
      </Button>
    </div>
  );
};

export default AffiliateCodeInput;
